"use strict";

import SVGPathCommander from "./main.ts";

export * from "./types.ts";
export * from "./interface.ts";

export default SVGPathCommander;
export {};
